import type { ModeState } from '../lib/api.ts';

/**
 * The permanent state strip.
 *
 * Three facts have to be visible at all times, because acting on the wrong
 * belief about any of them is expensive: which method is running, whether the
 * system may place orders, and whether Phase 0 is still collecting.
 *
 * The execution state is the loud one. "Detecting only" is the safe, expected
 * condition and is drawn quietly in green; "execution live" is drawn in red,
 * because that is the state where a mistake costs real money and nobody should
 * ever be surprised to find the system in it.
 */
export function ModeBanner({ mode }: { mode: ModeState | null }) {
  if (!mode) return null;

  const live = mode.executionEnabled;

  return (
    <div className={`mode-banner ${live ? 'live' : 'safe'}`}>
      <span className="mode-chip">{mode.info.label}</span>

      <span className={live ? 'red' : 'green'}>
        <strong>{live ? '● EXECUTION LIVE' : '○ detecting only'}</strong>
      </span>

      <span className="dim mode-note">
        {live
          ? 'Real orders can be placed with real money.'
          : 'No orders will be placed. The master guard is off.'}
      </span>

      {mode.pocMeasurement && (
        <span className="pill" title="Phase 0 gap-persistence measurement is collecting data">
          Phase 0 measuring
        </span>
      )}

      {mode.mode === 'transfer' && mode.transfer && (
        <span className="faint mode-note">
          Surfacing ≥{mode.transfer.minNetPct}% net · ~{mode.transfer.expectedMinutes} min transit
        </span>
      )}
    </div>
  );
}
